import { Box, Typography, Stack } from '@mui/material';
import { BrandSwitch } from '../../../../components/BrandSwitch';
import { useGlobalBrandKey } from '../../../../utils/globalState';
import { useHistory, useParams } from 'react-router-dom';
import { DEFAULT_ALLOWED_FORMAT } from '../../constants';
import type { FC } from 'react';

export const BrandSelection: FC = () => {
  const [brandKey, setBrandKey] = useGlobalBrandKey();
  const history = useHistory();
  const routeParams = useParams();

  // Handle brand selection and navigate immediately
  const handleBrandKeyChange = (newBrandKey: any) => {
    setBrandKey(newBrandKey);

    // Navigate to the proper Pages route with the selected brand
    const format = routeParams.format || DEFAULT_ALLOWED_FORMAT.toLowerCase();
    const newPath = `/${newBrandKey}/page/${format}/list`;
    history.push(newPath);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        padding: 4,
        marginTop: 4,
      }}
    >
      <Stack spacing={3} alignItems="center">
        <Typography variant="h5" color="primary" align="center">
          Sélectionner une marque
        </Typography>

        <Typography variant="body1" color="text.secondary" align="center">
          Veuillez choisir une marque :{' '}
          <Box
            component="span"
            sx={{
              display: 'inline-block',
              ml: 0.5,
              backgroundColor: 'primary.main',
              borderRadius: 0.5,
              px: 0.75,
              py: 0.25,
              '& *': {
                color: 'white !important',
                backgroundColor: 'transparent !important',
                fontSize: '0.8rem !important',
              },
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'transparent !important',
                border: 'none !important',
                minHeight: 'auto !important',
                '& .MuiOutlinedInput-input': {
                  padding: '2px 4px !important',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none !important',
                },
              },
              '& .makeStyles-buttonRoot-16': {
                padding: '2px 6px !important',
              },
            }}
          >
            <BrandSwitch
              brandKey={brandKey}
              setBrandKey={handleBrandKeyChange}
            />
          </Box>
        </Typography>
      </Stack>
    </Box>
  );
};
